var React = require('react');

function BlobInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#e0e0e0","opacity":"0.3","d":"M12.7,-9.3C24.2,-5.5,46.5,-8.8,56.7,-2.4C66.8,4,64.8,20.1,56.9,32C49,43.8,35.2,51.3,21.3,54.9C7.3,58.4,-6.9,58.1,-22.8,55.4C-38.7,52.7,-56.4,47.7,-66.4,35.7C-76.4,23.7,-78.9,4.7,-71.3,-8.1C-63.7,-21,-46.2,-27.6,-32.7,-30.9C-19.1,-34.3,-9.6,-34.4,-4.5,-29.1C0.6,-23.8,1.2,-13,12.7,-9.3Z","transform":"translate(100 100)"}));
}

BlobInline.defaultProps = {"viewBox":"24.26 66.71 139.31 90.77","width":"100"};

module.exports = BlobInline;

BlobInline.default = BlobInline;
